<template>
    <div class="centercontainer">
        <div class="center">
            <h2>{{ $t('common.pageNotPermitted') }}</h2>
        </div>
    </div>
</template>
